import axios from "axios";
import { ASSIGN_APPLICATION_LIST, ASSIGN_MODULE_LIST } from "../apiClient/apiEndpoints"
import { applicationCategoryId, environmentFilterId, moduleFilterId, SSO_URL, UNO_URL } from "../env";
import { saveUserData } from "../Store/slice/userSlice";
import { MODULE_LIMIT, TABS_TYPE_KEY } from "../Constant/constant";
import apiClient from "../apiClient";
import { getApplicationUsingTagCategory, getEnvironmentTagCategories, getModuleTagCategories } from "../apiClient/apiDataFetcher";


export const getUserDetails = async (token) => {
    let { data } = await axios.get(`${UNO_URL}/api/user/me`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });
    return data
}
// export const tagDetails = async (SSO_URL, UUID) => {
//   let  data  = await apiClient.get(`${SSO_URL}${CATEGORY_TAGS_LIST}/${UUID}`, {
//     params: {
//       limit: MODULE_LIMIT,
//       page: page || 1,
//       search: queryParams?.search || null,
//       tagIds: queryParams?.tagIds || null,
//       platforms: queryParams?.platforms || null,
//     },
//   });
//   return data;
// };

export const getAssignedModuleList = async ({ SSO_URL, UUID, queryParams, resourceType }) => {
    let page = queryParams?.page || 1;
    let data = await apiClient.get(`${SSO_URL}${ASSIGN_MODULE_LIST}/${TABS_TYPE_KEY[resourceType]}/${UUID}`, {
        params: {
            limit: MODULE_LIMIT,
            page: page || 1,
            search: queryParams?.search || null,
            tagIds: queryParams?.tagIds || null,
            platforms: queryParams?.platforms || null,
        }
    });
    return data;
}

export const getAssignedApplication = async ({ SSO_URL, UUID, queryParams }) => {
    let page = queryParams?.page || 1;
    let data = await apiClient.get(`${SSO_URL}${ASSIGN_APPLICATION_LIST}/${UUID}`, {
        params: {
            limit: MODULE_LIMIT,
            page: page || 1,
            search: queryParams?.search || null,
            tagIds: queryParams?.tagIds || null,
            platforms: queryParams?.platforms || null,
        }
    });
    return data
}


export const fetchInitialAppData = async (dispatch, token) => {
    getModuleTagCategories(dispatch, UNO_URL, moduleFilterId);
    getEnvironmentTagCategories(dispatch, UNO_URL, environmentFilterId);
    getApplicationUsingTagCategory(dispatch, UNO_URL, applicationCategoryId, token);
    // tagDetails(UNO_URL,)
}